import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Interfaces
export interface DeleteAttachmentResponse {
  message?: string;
}

// Axios request
export function deleteAttachment(
  chat_session_uid: string,
  attachment_uid: string,
): Promise<AxiosResponse<DeleteAttachmentResponse>> {
  return axios.delete<DeleteAttachmentResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/${chat_session_uid}/attachments/${attachment_uid}`,
  );
}
